
import { defineComponent, ref } from 'vue';
import { useWCCacheMap } from '@/shared/useWCCacheMap';

export default defineComponent({
  name: 'ScriptLoader',
  props: {
    wc: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const isLoaded = ref(false);

    const { scriptLoader } = useWCCacheMap();

    function initScript() {
      scriptLoader(props.wc).then(() => {
        isLoaded.value = true;
      });
    }

    initScript();

    return {
      isLoaded
    };
  }
});
